import { ITEMS_GET } from '@/utils/constants/api-endpoints'

export const get = async hash => {
  const url = new URL(CONFIG.api.url + ITEMS_GET)

  if (hash) {
    url.searchParams.append('hash', hash)
  }

  const resp = await fetch(url)
  const json = await resp.json()

  if (!resp.ok) {
    if (json?.response?.message) {
      throw new Error(json.response.message)
    }

    throw json
  }

  return json?.response ?? json
}
